import { Tooltip } from 'antd';
import React from 'react';
import { connect } from 'react-redux';
import { Enums, Cookies } from '../../helpers';

class Connection extends React.Component {

	render() {
		const { connected, connecting, connectSlow, feedId } = this.props;
window.log("feed id" ,feedId,connected)	
	if (connected)
			return (
				<div title="Connected" className="connection connection-signalr-success"></div>
			)

		if (connectSlow)
			return (
				<div title="Connection Slow" className="connection warning"></div>
			)

		if (connecting)
			return (
				<div title="Connecting" className="connection info"></div>
			)

		if ((!connected ) && !connecting)
			return (
				<div title="Disconnected" className="connection error"></div>
			)
	}
}

const mapStateToProps = (state) => {

	return {
		feedId: state.app.feedId,
		connected: state.app.feedId ? (state.app.feedId == Enums.Feed.Static ?
			state.signalr.staticConnected :
			state.app.feedId == Enums.Feed.Slots ?
				(Cookies.get("token") ? state.signalr.booongoConnected : state.signalr.staticConnected ) : 
				state.app.feedId == Enums.Feed.Live ?
				state.signalr.liveConnected :
				state.app.feedId == Enums.Feed.Casino || state.app.feedId == Enums.Feed.SpinAndWin ?
				state.signalr.spinAndWinConnected :
				state.app.feedId == Enums.Feed.LuckyNumbers ?
				state.signalr.luckyNumbersConnected :
				state.signalr.virtualConnected) : state.signalr.staticConnected,
		connecting: state.app.feedId == Enums.Feed.Static ?
			state.signalr.staticConnecting :
			state.app.feedId == Enums.Feed.Slots ?
				state.signalr.booongoConnecting :
				state.app.feedId == Enums.Feed.Live ?
				state.signalr.liveConnecting :
				state.app.feedId == Enums.Feed.Casino || state.app.feedId == Enums.Feed.SpinAndWin ?
				state.signalr.spinAndWinConnecting :
				state.app.feedId == Enums.Feed.LuckyNumbers ?
				state.signalr.luckyNumbersConnecting :
				state.signalr.virtualConnecting,
		connectSlow: state.signalr.connectSlow,
		staticConnected: state.signalr.staticConnected, 
		booongoConnected: state.signalr.booongoConnected, 
		liveConnected: state.signalr.liveConnected, 
		spinAndWinConnected: state.signalr.spinAndWinConnected, 
		luckyNumbersConnected: state.signalr.luckyNumbersConnected, 
		luckyNumbersConnecting: state.signalr.luckyNumbersConnecting, 
		virtualConnected: state.signalr.virtualConnected, 
	}
}

const mapDispatchToProps = (dispatch) => {
	return {}
}

export default connect(mapStateToProps, mapDispatchToProps)(Connection);